import { render, staticRenderFns } from "./PlaceDashboard.vue?vue&type=template&id=26c6be86&scoped=true"
import script from "./PlaceDashboard.vue?vue&type=script&lang=js"
export * from "./PlaceDashboard.vue?vue&type=script&lang=js"
import style0 from "./PlaceDashboard.vue?vue&type=style&index=0&id=26c6be86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c6be86",
  null
  
)

export default component.exports